import React from 'react';
import { ListBoxItemElement, SelectAllCheckbox } from './list-box.styles.js';
const getSelectAllLabel = (totalItemsCount, selectedItemsCount, labels) => {
    if (selectedItemsCount === 0) {
        return `${labels.selectAllLabel} (${totalItemsCount})`;
    }
    return `${labels.selectedLabel} (${selectedItemsCount}/${totalItemsCount})`;
};
export const ListBoxSelectAll = ({ state, selectAll, loading, dataAutomation = 'select-all-list-item', }) => {
    const currentlyShowingKeys = Array.from(state.collection.getKeys());
    const allSelectedKeys = Array.from(state.selectionManager.selectedKeys) || [];
    const totalItemsCount = state.collection.size;
    const selectedItemsCount = allSelectedKeys.filter((key) => currentlyShowingKeys.includes(key)).length;
    if (!selectAll ||
        loading ||
        state.selectionManager.selectionMode !== 'multiple' ||
        totalItemsCount === 0) {
        return null;
    }
    const someItemsSelected = selectedItemsCount > 0;
    const notAllItemsSelected = totalItemsCount > selectedItemsCount;
    const someButNotAllItemsSelected = someItemsSelected && notAllItemsSelected;
    const onClick = (event) => {
        if (notAllItemsSelected) {
            const newSelection = Array.from(new Set([...allSelectedKeys, ...currentlyShowingKeys]));
            state.selectionManager.setSelectedKeys(newSelection);
        }
        else {
            const newSelection = allSelectedKeys.filter((key) => !currentlyShowingKeys.includes(key));
            state.selectionManager.setSelectedKeys(newSelection);
        }
        state.selectionManager.setFocusedKey(null);
        event?.preventDefault();
        event?.stopPropagation();
    };
    const label = getSelectAllLabel(totalItemsCount, selectedItemsCount, selectAll);
    return (React.createElement(ListBoxItemElement, { "data-automation": dataAutomation, onClick: onClick },
        React.createElement(SelectAllCheckbox, { label: label, dataAutomation: `${dataAutomation}/checkbox`, isSelected: someItemsSelected, showSelectionAsPartial: someButNotAllItemsSelected, excludeFromTabOrder: true, disableHoverStyling: true })));
};
//# sourceMappingURL=list-box-select-all.component.js.map